// extracted by mini-css-extract-plugin
module.exports = {"panel":"InfoPanel_panel__1vFmS","info":"InfoPanel_info__2Ntcx","gutterBottom":"InfoPanel_gutterBottom__bWtoJ","textPerson":"InfoPanel_textPerson__35JLI"};